import type { State } from 'redux-store/Store';

export const selectInvoiceStatus = (state: State) => state.purchase.state;
export const selectPurchaseEntity = (state: State) => state.purchase;
